import {
    SET_WEBVIEW_GUARD,
    SET_GUARD_PASS,
    SET_SHOW_MADE_VIA_DIGARSON,
    SET_GUARD_MODE,
    SET_GUARD_CITY_ID,
    SET_GUARD_OUTLET_ID,
    SET_GUARD_TYPE_ID,
    SET_GUARD_CITIES,
    SET_GUARD_OUTLETS,
    SET_GUARD_TYPES,
    SET_GUARD_ADDRESS_ENABLED,
    SET_GUARD_ADDRESS,
    SET_GTM_TAG,
    SET_GEO_ADDRESS,
    SET_LOADING,
    SET_GUARD_MODE_INITIAL,
    SET_GUARD_AREA_ID,
    SET_GUARD_AREAS,
    SET_GUARD_AREA_TYPE_ID,
    SET_NOT_WORKING,
    SET_WHITE_LABEL,
    SET_SHOW_CHOOSE_OUTLETS_ALWAYS,
    SET_CSS_DIRECTION,
    SET_CHECK_IIKO,
    SET_NOT_ACCESS,
    SET_COMPANY_NAME,
} from '@/store/mutations.type'

import {
    DISABLE_OVERLAY,
    ENABLE_OVERLAY,
    GUARD_BACK,
    GUARD_DISABLE,
    GUARD_INIT,
    GUARD_NEXT,
    GUARD_SORT_OUTLETS,
    SET_GLOBAL_ERROR,
    GUARD_CHECK_IIKO,
    FETCH_OUTLET,
} from '@/store/actions.type'

import Vue from 'vue'
import axios from 'axios'
import api from '@/api'
import loader from '@/loader'

const GUARD_MODE_CITY = 0
const GUARD_MODE_ORDER_TYPE_AND_OUTLETS = 1
const GUARD_MODE_OUTLETS = 2
const GUARD_MODE_ADDRESS = 21
const GUARD_MODE_AREA = 22
const GUARD_MODE_SKIP = 100

const state = {
    webviewGuard: null,
    guardModeInitial: null,
    guardMode: null,
    guardPass: null,

    addressEnabled: false,
    address: null,

    notWorking: null,

    cityID: null,
    cities: [],
    typeID: null,
    types: [],
    outletID: null,
    outlets: [],
    areaID: null,
    areaTypeID: null,
    areas: [],
    guardShowChooseOutletsAlways: null,
    cssDirection: 'ltr',
    checkIiko: null,
    notAccess: null,
    companyName: '',

    guardModes: {
        GUARD_MODE_CITY,
        GUARD_MODE_ORDER_TYPE_AND_OUTLETS,
        GUARD_MODE_OUTLETS,
        GUARD_MODE_ADDRESS,
        GUARD_MODE_AREA,
        GUARD_MODE_SKIP
    }

}

const getters = {
    guardCheckIiko(state) {
        return state.checkIiko
    },
    webviewGuard(state) {
        return state.webviewGuard
    },
    guardMode(state) {
        return state.guardMode
    },
    guardModeInitial(state) {
        return state.guardModeInitial
    },
    guardModes(state) {
        return state.guardModes
    },
    guardPass(state) {
        return state.guardPass
    },
    guardAddressEnabled(state) {
        return state.addressEnabled
    },
    guardAddress(state) {
        return state.address
    },
    guardCityID(state) {
        return state.cityID
    },
    guardTypeID(state) {
        return state.typeID
    },
    guardOutletID(state) {
        return state.outletID
    },
    guardAreaID(state) {
        return state.areaID
    },
    guardAreaTypeID(state) {
        return state.areaTypeID
    },
    guardCities(state) {
        return state.cities
    },
    guardTypes(state) {
        return state.types
    },
    guardOutlets(state) {
        return state.outlets
    },
    guardAreas(state) {
        return state.areas
    },
    notWorking(state) {
        return state.notWorking
    },
    guardShowChooseOutletsAlways(state) {
        return state.guardShowChooseOutletsAlways
    },
    guardCssDirection(state) {
        return state.cssDirection
    },
    notAccess(state) {
        return state.notAccess
    },
    companyName(state) {
        return state.companyName
    },
    isBookingMode() {
        return state.typeID === 4
    }
}


export const mutations = {
    [SET_CHECK_IIKO](state, data) {
        state.checkIiko = data
    },
    [SET_SHOW_CHOOSE_OUTLETS_ALWAYS](state, data) {
        state.guardShowChooseOutletsAlways = data
    },
    [SET_WEBVIEW_GUARD](state, data) {
        state.webviewGuard = Boolean(data)
    },
    [SET_NOT_WORKING](state, data) {
        state.notWorking = data
    },
    [SET_GUARD_MODE](state, data) {
        state.guardMode = data
    },
    [SET_GUARD_MODE_INITIAL](state, data) {
        state.guardModeInitial = data
    },
    [SET_GUARD_PASS](state, data) {
        state.guardPass = data
    },
    [SET_GUARD_ADDRESS_ENABLED](state, data) {
        state.addressEnabled = Boolean(data)
    },
    [SET_GUARD_ADDRESS](state, data) {
        state.address = data
    },
    [SET_GUARD_CITY_ID](state, data) {
        state.cityID = data
    },
    [SET_GUARD_OUTLET_ID](state, data) {
        state.outletID = data
    },
    [SET_GUARD_AREA_ID](state, data) {
        state.areaID = data
    },
    [SET_GUARD_AREA_TYPE_ID](state, data) {
        state.areaTypeID = data
    },
    [SET_GUARD_TYPE_ID](state, data) {
        state.typeID = data
    },
    [SET_GUARD_CITIES](state, data) {
        state.cities = data
    },
    [SET_GUARD_OUTLETS](state, data) {
        state.outlets = data
    },
    [SET_GUARD_AREAS](state, data) {
        state.areas = data
    },
    [SET_GUARD_TYPES](state, data) {
        state.types = data
    },
    [SET_CSS_DIRECTION](state, data) {
        state.cssDirection = data
    },
    [SET_NOT_ACCESS](state, data) {
        state.notAccess = data
    },
    [SET_COMPANY_NAME](state, data) {
        state.companyName = data
    },

}

export const actions = {
    [GUARD_CHECK_IIKO](context, data) {
        context.commit(SET_CHECK_IIKO, data)
    },

    async [GUARD_INIT](context) {
        await axios({
            method: 'GET',
            url: api.guard.init.url({ typeID: context.getters.guardTypeID })
        }).then(async response => {
            context.commit(SET_SHOW_MADE_VIA_DIGARSON, !response.data.is_prototype)
            context.commit(SET_GUARD_ADDRESS_ENABLED, response.data.address_input_enabled)
            context.commit(SET_GTM_TAG, response.data.gtmTag)
            context.commit(SET_NOT_WORKING, response.data.notWorking)
            if (response.data.companyName) {
                document.title = response.data.companyName
                context.commit(SET_COMPANY_NAME, response.data.companyName)
            }

            if (response.data.cities) {
                context.commit(SET_GUARD_CITIES, response.data.cities)
            }
            if (response.data.types) {
                context.commit(SET_GUARD_TYPES, response.data.types)
            }
            if (response.data.outlets) {
                context.commit(SET_GUARD_OUTLETS, response.data.outlets)
            }
            if (response.data.areas) {
                context.commit(SET_GUARD_AREAS, response.data.areas)
            }
            if (response.data.city_id) {
                context.commit(SET_GUARD_CITY_ID, response.data.city_id)
            }
            if (response.data.type_id) {
                context.commit(SET_GUARD_TYPE_ID, response.data.type_id)
            }
            if (response.data.outlet_id) {
                context.commit(SET_GUARD_OUTLET_ID, response.data.outlet_id)
            }
            if (response.data.area_id) {
                context.commit(SET_GUARD_AREA_ID, response.data.area_id)
            }
            if (response.data.area_type_id) {
                context.commit(SET_GUARD_AREA_TYPE_ID, response.data.area_type_id)
            }
            if (response.data.show_choose_outlets_always) {
                context.commit(SET_SHOW_CHOOSE_OUTLETS_ALWAYS, response.data.show_choose_outlets_always)
            }

            if (response.data.notAccess) {
                context.commit(SET_NOT_ACCESS, response.data.notAccess)
            }

            await context.commit(SET_GUARD_MODE, response.data.initial_mode)
            context.commit(SET_GUARD_MODE_INITIAL, response.data.initial_mode)

            if (response.data.identifier) {
                await context.commit(SET_GUARD_PASS, response.data.identifier)
                if (context.getters.guardMode === context.getters.guardModes.GUARD_MODE_SKIP || context.rootState.settings.contactlessMode) {
                    await context.dispatch(GUARD_DISABLE)
                } else {
                    await context.dispatch(DISABLE_OVERLAY)
                }
            } else {
                await context.dispatch(DISABLE_OVERLAY)
            }

            if (response.data.whiteLabel) {
                await context.commit(SET_WHITE_LABEL, response.data.whiteLabel)
            }
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    },

    async [GUARD_SORT_OUTLETS](context) {

        if (context.getters.loading[GUARD_SORT_OUTLETS]) {
            return
        }

        context.commit(SET_LOADING, { process: GUARD_SORT_OUTLETS, loading: true })

        navigator.geolocation.getCurrentPosition(pos => {

            axios({
                method: 'POST',
                url: api.guard.sortOutlets.url(),
                data: {
                    latitude: pos.coords.latitude,
                    longitude: pos.coords.longitude,
                    typeID: 1,
                    cityID: context.getters.guardCityID
                }
            }).then(response => {
                if (response.data.outlets) {
                    let newIdentifiers = []
                    for (let responseKey in response.data.outlets) {
                        newIdentifiers.push(response.data.outlets[responseKey].identifier)
                    }
                    let outlets = context.getters.guardOutlets
                    let i = outlets.length
                    while (i--) {
                        if (newIdentifiers.includes(outlets[i].identifier)) {
                            outlets.splice(i, 1)
                        }
                    }

                    outlets = outlets.concat(response.data.outlets)

                    context.commit(SET_GUARD_OUTLETS, outlets)
                }
            }).catch(error => {
                context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
            }).finally(() => {
                context.commit(SET_LOADING, { process: GUARD_SORT_OUTLETS, loading: false })
            })

        }, err => {
            context.commit(SET_LOADING, { process: GUARD_SORT_OUTLETS, loading: false })
        }, { timeout: 5000, enableHighAccuracy: true })


    },


    async [GUARD_DISABLE](context) {
        let overlay = document.getElementById('overlay')
        await context.dispatch(DISABLE_OVERLAY)
        overlay.outerHTML = getOverlayHtml()
        await context.dispatch(ENABLE_OVERLAY)
        await context.commit(SET_WEBVIEW_GUARD, false)
        await loader.router.push({ name: 'home', params: { token: context.getters.token } })
    },

    async [GUARD_NEXT](context) {

        if (context.getters.guardMode === context.getters.guardModes.GUARD_MODE_CITY) {
            return context.commit(SET_GUARD_MODE, context.getters.guardModes.GUARD_MODE_ORDER_TYPE_AND_OUTLETS)
        }
        if (context.getters.guardTypeID === 3 && context.getters.guardMode === context.getters.guardModes.GUARD_MODE_ORDER_TYPE_AND_OUTLETS) {
            if (context.getters.guardAddressEnabled) {
                return context.commit(SET_GUARD_MODE, context.getters.guardModes.GUARD_MODE_ADDRESS)
            }
            if (!context.getters.guardAddressEnabled && context.getters.guardAreas.length > 0) {
                return context.commit(SET_GUARD_MODE, context.getters.guardModes.GUARD_MODE_AREA)
            }
        }
        if (context.getters.isBookingMode) { 
            await loader.router.push({ name: 'booking' })
            return
        }

        if (context.getters.guardCityID && context.getters.guardTypeID && context.getters.guardOutletID && context.getters.guardPass) {
            return context.dispatch(GUARD_DISABLE)
        }
    },

    async [GUARD_BACK](context) {
        if (context.getters.guardMode === context.getters.guardModes.GUARD_MODE_ORDER_TYPE_AND_OUTLETS) {
            return context.commit(SET_GUARD_MODE, context.getters.guardModes.GUARD_MODE_CITY)
        }

        if (
            context.getters.guardMode === context.getters.guardModes.GUARD_MODE_ADDRESS ||
            context.getters.guardMode === context.getters.guardModes.GUARD_MODE_AREA
        ) {
            if (
                context.getters.guardTypes.filter(type => type.city_id === context.getters.guardCityID).length === 1 &&
                context.getters.guardOutlets.filter(outlet => outlet.city_id === context.getters.guardCityID && outlet.type_id === context.getters.guardTypeID).length === 1
            ) {
                context.commit(SET_GUARD_CITY_ID, null)
                context.commit(SET_GUARD_OUTLET_ID, null)
                context.commit(SET_GUARD_TYPE_ID, null)
                context.commit(SET_GUARD_PASS, null)
                return context.commit(SET_GUARD_MODE, context.getters.guardModes.GUARD_MODE_CITY)
            } else {
                context.commit(SET_GUARD_OUTLET_ID, null)
                context.commit(SET_GUARD_TYPE_ID, null)
                context.commit(SET_GUARD_PASS, null)
                return context.commit(SET_GUARD_MODE, context.getters.guardModes.GUARD_MODE_ORDER_TYPE_AND_OUTLETS)
            }
        }
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}